module.exports = __webpack_public_path__ + "assets/img/ico-6.0628b5b7.png";